let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8;
import styled, { css } from 'styled-components';
import { colors, styledIf } from '@ovpn-ui/styles';
import Box from '../Box';
import { shadows } from '../styles';
const transition = css(_t || (_t = _`
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
`));
export const Container = styled(Box)(_t2 || (_t2 = _`
    position: relative;

    display: inline-flex;
    flex-direction: ${0};
    gap: 8px;

    cursor: pointer;

    ${0}

    & .ovpn-radio-input {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        opacity: 0;
    }
`), ({
  $direction
}) => $direction === 'ltr' ? 'row' : 'row-reverse', styledIf('$disabled')(_t3 || (_t3 = _`pointer-events: none;`)));
const sizeDefault = css(_t4 || (_t4 = _`
    width: 20px;
    height: 20px;
    &:before {
        border-radius: 20px;
    }
    &:after {
        top: 4px;
        left: 4px;

        width: 12px;
        height: 12px;

        border-radius: 20px;
    }
`));
const sizeSmall = css(_t5 || (_t5 = _`
    width: 16px;
    height: 16px;

    &:before {
        border-radius: 16px;
    }

    &:after {
        top: 3px;
        left: 3px;

        width: 10px;
        height: 10px;

        border-radius: 16px;
    }
`));
export const Appearance = styled.span(_t6 || (_t6 = _`
    position: relative;

    display: inline-block;
    flex-shrink: 0;

    width: 100%;
    height: 100%;
    ${0}

    &:before,
    &:after {
        position: absolute;
        top: 0;
        left: 0;

        content: '';
    }

    &:before {
        width: 100%;
        height: 100%;

        background-color: ${0};
        border: 1px solid;
        border-color: ${0};
        box-shadow: ${0};

        ${0}

        transition-property: background-color, box-shadow;
    }

    &:after {
        background-color: ${0};

        transform: scale(0, 0);

        ${0}

        transition-property: transform;
    }

    ${0};

    .ovpn-radio-input:hover + & {
        &:before {
            background-color: ${0};
        }
        &:after {
            background-color: ${0};
        }
    }

    .ovpn-radio-input:focus + & {
        &:before {
            background-color: ${0};
            box-shadow: ${0};
        }
    }

    .ovpn-radio-input:not(:checked) + & {
        &:after {
            background-color: ${0};
        }
    }

    .ovpn-radio-input:focus:not(:checked) + & {
        &:after {
            top: 1px;
            left: 1px;

            width: calc(100% - 2px);
            height: calc(100% - 2px);

            background-color: ${0};
            transform: scale(1);
        }
    }

    .ovpn-radio-input:checked + & {
        &:after {
            transform: scale(1);
        }
    }

    .ovpn-radio-input:checked:hover + & {
        &:before {
            background-color: ${0};
            border-color: ${0};
        }
        &:after {
            background-color: ${0};
            transform: scale(1);
        }
    }
`), styledIf('$withContent')(_t7 || (_t7 = _`margin-top: 2px;`)), ({
  $disabled
}) => $disabled ? colors.neutralLight : colors.neutralBg, ({
  $disabled
}) => $disabled ? colors.neutralBorder : colors.primaryBase, ({
  $disabled
}) => $disabled ? 'none' : shadows.sm, transition, ({
  $disabled
}) => $disabled ? colors.neutralBorder : colors.primaryBase, transition, ({
  $small
}) => $small ? sizeSmall : sizeDefault, colors.neutralBgHover, colors.neutralWhite, colors.neutralBgHover, shadows.focusedBlue, colors.primaryBase, colors.neutralWhite, colors.neutralWhite, colors.primaryBase, colors.primaryBase);
export const ContentWrapper = styled(Box)(_t8 || (_t8 = _`
    display: flex;
    flex-direction: column;
`));